import axios from "axios";
import { urls } from "../../utils/AppManager";
import { getAuthHeaders } from '../../utils/headers'

export const getDeletedLeadsList = async (
  payload,
  fromDate,
  toDate,
  searchPhone,
  deletedBy
) => {
    const body = {
    pageNumber: payload.currentPage,
    pageSize: payload.leadsRecords,
    fromDate: fromDate,
    toDate: toDate,
    searchPhone: searchPhone,
    deletedBy: deletedBy,
  };

  const url = `${process.env.REACT_APP_API_BASE_URL}${urls.deletedLeads}`;

  const headers = {
    ...getAuthHeaders(),
    "Content-Type": "application/json",
  };

  try{
    const response = await axios.post(url, body, {headers});
    return response?.data;
  } catch(error) {
    console.error("Error fetching deleted leads list",error);
    throw error;
  }
};

export const getDeletedLeadBy = async() => {
  const url = process.env.REACT_APP_API_BASE_URL + urls.deletedLeadBy;
  const headers = getAuthHeaders();
  const res = await axios.get(url, {headers})
  .then((response) => response?.data)
  .catch((error) => {
    console.error("error",error);
  });
  return res;
}